import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {UserRequestDetailComponent} from "../user-request-detail/user-request-detail.component";
import {DynamicModalFormComponent} from "../../../common/dynamic-modal-form/dynamic-modal-form.component";
import {
  UserRequestComparatorComponent
} from "../../../common/user-request-comparator/user-request-comparator.component";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {UserRequest} from "../../../../model/UserRequest";
import {FaqCategory} from "../../../../model/FaqCategory";

@Component({
    selector: 'app-user-requests-accept',
    imports: [
        CommonModule,
        DynamicModalFormComponent,
        UserRequestComparatorComponent,
        BadgeComponent,
        FaIconComponent,
        UserRequestDetailComponent
    ],
    templateUrl: './user-requests-accept.component.html',
    styleUrl: './user-requests-accept.component.scss'
})
export class UserRequestsAcceptComponent {
  @Input()
  request: UserRequest;
  @Input()
  crmUrl: string;
  @Input()
  categories: FaqCategory[] = [];

  @Output()
  submit = new EventEmitter();
  @Output()
  cancel = new EventEmitter();

  getCategoryFromSlug(p: any): FaqCategory {
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.toLowerCase();
    });
  }

  onSubmit($event): void {
    this.submit.emit($event);
  }

  onCancel() {
    this.cancel.emit();
  }
}
